/* eslint-disable func-names  */
import React from 'react';
import Layout from '../components/Layout';

import HomeHeader from '../components/Home/HomeHeader';
import HomePartners from '../components/Home/HomePartners';
import HomeTestimonials from '../components/Home/HomeTestimonials';
import HomeIndustries from '../components/Home/HomeIndustries';
import ResultsCardSwiperSection from '../components/ResultsCardSwiperSection';
import HomeKnowledge from '../components/Home/HomeKnowledge';
import PartialsQuestion from '../components/Partials/PartialsQuestion';
import LazyLoad from '../components/LazyLoad';

const IndexPage = () => {
  return (
    <Layout
      title="Ulam Labs - Python & Blockchain Software Development"
      description="We are a software development company that specializes in Python and blockchain technology. We provide full scope development support throughout the whole product lifecycle for both web applications and mobile apps."
    >
      <HomeHeader />
      <HomePartners />
      <LazyLoad
        className="lazy-index-components"
        loader={<div style={{ height: '400px' }} />}
      >
        <HomeTestimonials
          customTitle="Testimonials"
          customSubtitle="Let our delighted customers do the talking."
        />
        <HomeIndustries />
        <ResultsCardSwiperSection title="Learn how we solved our clients’ problems" />
        <HomeKnowledge />
        <PartialsQuestion />
      </LazyLoad>
    </Layout>
  );
};

export default IndexPage;
